'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.constant('jLoadingConfig', {
    // view: 100,
    // sideMenu: 150,
    // modal: 200,
    // actionSheet: 300,
    // popup: 400,
    // loading: 500,
    BACK_PRIORITY: 1000
  });
  app.factory('jLoading', function ($ionicPlatform, $rootScope, $document, $timeout, $compile, jLoadingConfig) {
    var timer = void 0,
        delay = 100,

    // 注册返回键
    _jLoadingBackButton = void 0;
    return {
      show: show,
      hide: hide,
      setMessage: function setMessage(message) {
        var el = document.getElementById('jLoading');
        el && (el.querySelector('.jLoading-title').innerHTML = message || '');
      }
    };

    function show(options) {
      $timeout.cancel(timer);
      timer = $timeout(function () {
        options || (options = {});
        var el = $document[0].body.querySelector('#jLoading');
        if (!el) {
          el = document.createElement('div');
          el.innerHTML = ['<div id="jLoading" class="jLoading">', '  <div class="jLoading-backdrop"></div>', '  <div class="jLoading-body">', '    <div class="jLoading-content">' + '         <ion-spinner class="jLoading-icon"></ion-spinner>' + '         <span class="jLoading-title"></span>' + '    </div>', '  </div>', '</div>'].join('');
          el = el.children[0];
          $compile(el)($rootScope.$new());
          $document[0].body.appendChild(el);
        }
        el.querySelector('.jLoading-title').innerHTML = options.message || '';
        if (options.message) {
          el.classList.add('jLoading-has-title');
        } else {
          el.classList.remove('jLoading-has-title');
        }
        el.classList.remove('hidden');
      }, delay);
      _jLoadingBackButton && _jLoadingBackButton();
      _jLoadingBackButton = $ionicPlatform.registerBackButtonAction(window.angular.noop, jLoadingConfig.BACK_PRIORITY);
    }

    function hide() {
      _jLoadingBackButton && _jLoadingBackButton();
      $timeout.cancel(timer);
      var el = document.getElementById('jLoading');
      el && $timeout(function () {
        el.classList.add('hidden');
      }, 200);
    }
  });
  return app;
};

require('angular');

require('ionic');

require('./index.scss');

/**
 * Alert
 * 结合$cordovaToast、$ionicPopup
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/loading/index.js
// module id = 161
// module chunks = 0